const alertTypes = {
    warning: "warning",
    error: "error",
    success: "success",
    info: "info"
}

export default alertTypes;